import { toLocalizedNumber } from "@configs/utils/utility";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import CheckIcon from "../../../assets/icons/Check";
import InProgressIcon from "../../../assets/icons/InProgress";
import Progress from "../../../components/Common/Progress";
import type { Trigger } from "../../../configs/apis/models";
import { TriggerId } from "../../../configs/models/constants";

export type DetailsCardProps = {
  isMoreThanOne: boolean;
  onViewClick?: () => void;
  trigger: Trigger | undefined;
  isCompleted: boolean | undefined;
};

const DetailsCard = ({ trigger, isCompleted = false }: DetailsCardProps) => {
  const { t: translate } = useTranslation("translation");
  const getTriggerType = (trigger: Trigger) => {
    const localizedNumber = toLocalizedNumber(trigger.actionLeft);
    return translate("only_left", { 0: localizedNumber });
  };
  return (
    <div className="flex items-center gap-4">
      {isCompleted ? (
        <div className="flex aspect-square items-center justify-center rounded-full border border-successColor p-3 text-successColor">
          <CheckIcon />
        </div>
      ) : (
        <div className="flex aspect-square items-center justify-center rounded-full border border-activeColor p-3 text-activeColor">
          <InProgressIcon />
        </div>
      )}
      <div className="w-full">
        <p className="font-semibold">
          {isCompleted
            ? translate("completed")
            : trigger?.triggerId === TriggerId.TIER ? translate("upgrade_your_tier") : getTriggerType(trigger as Trigger)}
        </p>
        <div className="flex items-center gap-1">
          <Progress
            className={clsx(isCompleted && "bg-successColor")}
            percentage={isCompleted ? 100 : trigger?.progress}
          />
          <span className="text-sm">
            {isCompleted ? 100 : trigger?.progress.toFixed(0)}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default DetailsCard;
